<script>

import axios from 'axios';

export default class AssinaturaRepository{
    

    async notify(token,id) {
        
        const baseURL = `${process.env.VUE_APP_API_URL}enviar-para-assinatura`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = {
            proposta_id : id
        };
        const response = await axios.post(baseURL,data,{ headers });
        return response;
       
    }

}
</script>
